/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BriefStepDto = {
    id?: string;
    type?: BriefStepDto.type;
    title?: string;
    durationMinutes?: number;
    orderPosition?: number;
};
export namespace BriefStepDto {
    export enum type {
        VIDEO = 'VIDEO',
        QUIZ = 'QUIZ',
    }
}

